import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlockedUsersPage = () => {
  const navigate = useNavigate();
  const [blockedUsers, setBlockedUsers] = useState([]);

  useEffect(() => {
    fetchBlockedUsers();
  }, []);

  const fetchBlockedUsers = async () => {
    try {
      const response = await axios.get(`${API}/blocked-users`);
      setBlockedUsers(response.data);
    } catch (error) {
      console.error('Error fetching blocked users:', error);
    }
  };

  const handleUnblock = async (blockedId) => {
    if (!confirm('Unblock this user?')) return;
    try {
      await axios.delete(`${API}/blocked-users/${blockedId}`);
      setBlockedUsers(blockedUsers.filter(u => u.id !== blockedId));
    } catch (error) {
      console.error('Error unblocking user:', error);
    }
  };

  const handleReport = async (userId, userName) => {
    const reason = prompt(`Report ${userName}\n\nPlease provide a reason:`);
    if (reason) {
      try {
        await axios.post(`${API}/blocked-users/${userId}/report`, { reason });
        alert('User reported successfully. Our team will review this.');
      } catch (error) {
        console.error('Error reporting user:', error);
      }
    }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button onClick={() => navigate('/profile')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#C8A878', padding: '8px' }}>
          <ArrowLeft size={24} />
        </button>
        <h1 className="page-title">Blocked Users</h1>
      </div>

      <div style={{ padding: '20px' }}>
        {blockedUsers.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#C8A878' }}>
            <p>No blocked users</p>
          </div>
        ) : (
          blockedUsers.map((user) => (
            <div key={user.id} className="card" style={{ marginBottom: '12px' }} data-testid={`blocked-${user.id}`}>
              <div style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                <img
                  src={user.blocked_user_photo}
                  alt={user.blocked_user_name}
                  style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                />
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '4px' }}>{user.blocked_user_name}</h3>
                  <p style={{ fontSize: '14px', color: '#F1E6D0' }}>
                    {user.blocked_user_age && `${user.blocked_user_age} • `}
                    {user.blocked_user_location}
                  </p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => handleUnblock(user.id)}
                  className="btn-secondary"
                  style={{ flex: 1 }}
                  data-testid={`unblock-${user.id}`}
                >
                  Unblock
                </button>
                <button
                  onClick={() => handleReport(user.blocked_user_id, user.blocked_user_name)}
                  className="btn-danger"
                  style={{ flex: 1 }}
                  data-testid={`report-${user.id}`}
                >
                  Report
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default BlockedUsersPage;
